<script>
import { SplitText } from '../../../utilities/SplitText';

export default {
    props: {
        delay: {
            type: Number,
            default: 0.25
        },
        once: {
            type: Boolean,
            default: false
        },
        toggleActions: {
            type: String,
            default: 'play none play none'
        }
    },

    mounted() {
        const split = new SplitText(this.$refs.wrapper, { type: 'words' });

        gsap.from(split.words, {
            y: '200%',
            opacity: 0,
            duration: 0.5,
            stagger: 0.06,
            delay: this.delay,
            ease: 'circ.out',
            scrollTrigger: {
                trigger: this.$refs.wrapper,
                once: this.once,
                toggleActions: this.toggleActions
            }
        });
    }
};
</script>
